import styled from 'styled-components';

const Burger = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  background: transparent;
  border: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLOR_PRIMARY};
  padding: 10px 10px;
  z-index: 10;
  top: 0;
  &:focus {
    outline: none;
  }
`;

const Line = styled.div`
  width: 24px;
  height: 2px;
  background: ${({ theme }) => theme.COLOR_WHITE};
  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;
  margin: 2px;
`;

const StyledBurger = {
  Burger,
  Line,
};

export default StyledBurger;
